var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.25C3.92925 2.25 2.25 3.92925 2.25 6V12C2.25 14.0708 3.92925 15.75 6 15.75H12C14.0708 15.75 15.75 14.0708 15.75 12V6C15.75 3.92925 14.0708 2.25 12 2.25H6ZM13.5 3.75C13.914 3.75 14.25 4.086 14.25 4.5C14.25 4.914 13.914 5.25 13.5 5.25C13.086 5.25 12.75 4.914 12.75 4.5C12.75 4.086 13.086 3.75 13.5 3.75ZM9 5.25C11.0708 5.25 12.75 6.92925 12.75 9C12.75 11.0708 11.0708 12.75 9 12.75C6.92925 12.75 5.25 11.0708 5.25 9C5.25 6.92925 6.92925 5.25 9 5.25ZM9 6.75C8.40326 6.75 7.83097 6.98705 7.40901 7.40901C6.98705 7.83097 6.75 8.40326 6.75 9C6.75 9.59674 6.98705 10.169 7.40901 10.591C7.83097 11.0129 8.40326 11.25 9 11.25C9.59674 11.25 10.169 11.0129 10.591 10.591C11.0129 10.169 11.25 9.59674 11.25 9C11.25 8.40326 11.0129 7.83097 10.591 7.40901C10.169 6.98705 9.59674 6.75 9 6.75Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.4b79f0f6734b2336f751e7730712ecd5.svg";
export { ForwardRef as ReactComponent };